import * as React from 'react';
import * as styles from './styles.css';

export const MyHomeListing: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <div className={styles['myhomelisting-container']}>{children}</div>;
};

MyHomeListing.displayName = 'MyHomeListing';
